<template>
    <div >
        <template v-if="isAimedia">
            <h4>文案</h4>
            <p v-for="(item, index) in params.title_list" :key="index">标题{{ index + 1 }}：{{ item }}</p>
            <el-divider></el-divider>
            <h4>图片</h4>
            <el-row :gutter="20" type="flex" align="top" style="margin-right: 90px;">
                    <el-col
                        :span="4"
                        v-for="(item, index) in params.img_list"
                        :key="index"
                    >
                        <CardItem :key="index" :material="{ ...item, material_type: 1 ,material_url:item.full_material_url  }"/>
                    </el-col>
            </el-row>
            <el-divider></el-divider>
            <!-- <h4>视频</h4> -->
            <el-row :gutter="20" type="flex" align="top" style="margin-right: 90px;">
                    <template v-for="(item, index) in params.video_list">
                        <el-col
                            :span="4"
                            
                            :key="index"
                        >
                            视频
                            <CardItem :key="index" :material="{ ...item, material_type: 2 ,material_url:item.full_material_url, material_name: item.material_name   }"/>
                        </el-col>
                        <el-col
                            :span="4"
                            
                            :key="index +'img'"
                        >   
                            封面
                            <CardItem :key="index" :material="{ ...item, material_type: 1 ,material_url:item.full_preview_material_url, material_name: item.preview_material_name   }"/>
                        </el-col>
                    </template>
                   
            </el-row>
        </template>
        <template v-else>
            <div v-for="(item, index) in params" :key="index">
                <el-row :gutter="20" type="flex" align="top">
                    <el-col
                        :span="4"
                        :offset="ii == 0 ? 1 : 0"
                        v-for="(ic, ii) in item.material"
                        :key="ii"
                    >
                        <CardItem :material="ic" />
                    </el-col>
                    <el-col :span="12"
                        ><div class="grid-content" style="padding-top: 34px">
                            <span
                                style="
                                    display: inline-block;
                                    width: 100%;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                    white-space: nowrap;
                                "
                            >
                                创意规格：{{ item.place_type_text }} -
                                {{ item.norm_model_text }}
                            </span>
                        </div></el-col
                    >
                </el-row>
                <el-divider></el-divider>
            </div>
        </template>
      
    </div>
</template>

<script>
import CardItem from "./cardItem"
export default {
    name: "expandItem",
    components: {
        CardItem,
    },
    props: {
        params: [ Array, Object ],
        isAimedia: Boolean,
    },
    data() {
        return {}
    },
    // computed: {
    //     params() {
    //         console.log(this.params)
    //     }
    // },
    mounted() {
    },
    methods: {},
}
</script>

<style scoped></style>
